import { injectReducer } from 'store/reducers.js'
import { authRoute } from 'helpers/routes'
import { injectExternalList } from 'helpers/actions'

export const ProductsRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'products',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/ProductsContainer').default

      const actions = require('./modules/products').actions
      const reducer = require('./modules/products').default

      injectReducer(store, { key: 'products', reducer })
      injectExternalList(store, 'categories')
      injectExternalList(store, 'customers')
      injectExternalList(store, 'types')

      store.dispatch(actions.get())

      cb(null, Container)
    }, 'products')
  }
})

export const NewProductRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'products/new',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/NewProductContainer').default

      const reducer = require('./modules/product').default

      injectReducer(store, { key: 'product', reducer })
      injectExternalList(store, 'categories')
      injectExternalList(store, 'customers')
      injectExternalList(store, 'options')
      injectExternalList(store, 'types')
      injectExternalList(store, 'uoms')

      cb(null, Container)
    }, 'products')
  }
})

export const EditProductRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'products/:id/edit',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/EditProductContainer').default

      const actions = require('./modules/product').actions
      const reducer = require('./modules/product').default

      injectReducer(store, { key: 'product', reducer })
      injectExternalList(store, 'categories')
      injectExternalList(store, 'customers')
      injectExternalList(store, 'options')
      injectExternalList(store, 'types')
      injectExternalList(store, 'uoms')

      store.dispatch(actions.get(nextState.params.id))

      cb(null, Container)
    }, 'products')
  }
})

export default function (store) {
  return [
    NewProductRoute(store),
    EditProductRoute(store),
    ProductsRoute(store)
  ]
}



// WEBPACK FOOTER //
// ./src/routes/Products/index.js